<template>
  <div class="radiobox">
    <input type="radio" v-model="value" :key="o" v-for="(opt, o) in options" :value="opt" :name="name"
    @click="clicked(opt)" :disabled="disabled ? true : false"
    :style="[round?{borderRadius: '30px'}:{}, height?{height}:{}, width?{width}:{}, color?{'--backgroundColor': color}:{'--backgroundColor': 'var(--color-pri)'}]">
  </div>
</template>

<script>
export default {
  props: ['options', 'defaultValue', 'round', 'height', 'width', 'color', 'name', 'disabled'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  methods: {
    clicked (opt) {
      if (opt === this.defaultValue) {
        this.$emit('same', opt)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radiobox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
input[type=radio] {
  appearance: none;
  background-color: #B9B9B9;
  padding-inline: 21px;
  height: 40px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  &:checked {
    background-color: var(--backgroundColor);
  }
  &::before {
    content: attr(value);
    white-space: nowrap;
  }
}
</style>
